export const parseOperation = (msg) => {
    let tokens = msg.split(" ");
    let operation = tokens[0];
    let args = tokens.slice(1).map(x => parseFloat(x));
    return [operation, args];
};


 
